/** The signed-in creator's access token, as the editor last handed it over (setJwt); the renderer never refreshes it. */
export class EditorSession {
  #jwt: string | null = null;

  /** window.lureoEditorJwt(): null until the first token. */
  getLatestJwt(): string | null {
    return this.#jwt;
  }

  /** EditorSession_GetJwt: the token, or "" before the first one. */
  getJwt(): string {
    return this.#jwt ?? "";
  }

  setLatestJwt(token: string): void {
    this.#jwt = token;
  }
}

/** The page's one session: the host writes it, the /api/v1 client reads it. */
export const editorSession = new EditorSession();

export function getLatestJwt(): string | null {
  return editorSession.getLatestJwt();
}
